import { connect } from 'react-redux';
import { StoreState } from '../../store/state';
import ManifestEventLogPage from './ManifestEventLogPage';
import { getManifestEventLog } from '../../store/actions/manifest';

// See https://reacttraining.com/react-router/web/api/match
interface OwnProps {
  match: {
    params: {
      locationKey: string,
      manifestId: string,
    },
  };
}

const defaults = { log: [], updated: undefined };

const mapStateToProps = (state: StoreState, ownProps: OwnProps) => {
  const manifestId = ownProps.match.params.manifestId;
  const loading = state.manifestEventLogs.isLoading;
  const { log, updated } = state.manifestEventLogs.all[manifestId] || defaults;
  return { manifestId, loading, manifestEventLog: log, lastUpdated: updated };
};

const mapDispatchToProps = {
  loadManifestEventLog: getManifestEventLog.request,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManifestEventLogPage);
